module.exports = __webpack_public_path__ + "img/toppage.7b74660e.jpg";